import { getLocale } from 'next-intl/server';

import { mapOptimizelyLocaleToIntlLocale } from '@shared/utils/helpers/map-optimizely-locale-to-intl-locale';

import { DEFAULT_LOCALE } from '../../../../i18n/locales';
import { getAllTranslatableLanguageCodes } from '../../../hooks/get-languages-content';

export const getContentInCurrentLanguage = async <
  T1 extends { Name?: null | string | undefined },
  T2 extends { Language?: null | T1 | undefined },
>(
  items: Array<null | T2> | null | undefined,
  providedLocale?: string
) => {
  if (items === undefined || items === null || items.length === 0) {
    return undefined;
  }

  const locale = providedLocale ?? (await getLocale());

  const isCurrentLanguageSupported = providedLocale
    ? true
    : (await getAllTranslatableLanguageCodes()).includes(locale);

  const itemsInCurrentLanguage = isCurrentLanguageSupported
    ? items.filter((item) =>
        item?.Language?.Name
          ? mapOptimizelyLocaleToIntlLocale(item?.Language?.Name) === locale
          : false
      )
    : [];

  const itemsInDefaultLanguage = items.filter((item) =>
    item?.Language?.Name
      ? mapOptimizelyLocaleToIntlLocale(item?.Language?.Name) === DEFAULT_LOCALE
      : false
  );

  if (itemsInCurrentLanguage.length > 0) {
    return itemsInCurrentLanguage;
  } else {
    return itemsInDefaultLanguage;
  }
};
